import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { LayoutService } from '@common/services/layout.service';
import { DataService } from '@services/data.service';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnDestroy {

  @ViewChild('header')
  private header: HeaderComponent;

  @ViewChild('body')
  private body: ElementRef;

  @ViewChild('sidebar')
  private sidebar: ElementRef;

  @ViewChild('content')
  private content: ElementRef;

  @ViewChild('footer')
  public footer: ElementRef;

  private contentObserver: any;
  private windowObserver: any;

  constructor(private ds: DataService, private ref: ElementRef, public layout: LayoutService) {
  }

  ngAfterViewInit() {

    let header: HTMLElement = this.header.nativeElement as HTMLElement;
    let body: HTMLElement = this.body.nativeElement as HTMLElement;
    let sidebar: HTMLElement = this.sidebar.nativeElement as HTMLElement;
    let content: HTMLElement = this.content.nativeElement as HTMLElement;
    let footer: HTMLElement = this.footer.nativeElement as HTMLElement;
    let root: HTMLElement = this.ref.nativeElement as HTMLElement;

    this.layout.use({
      header: () => header.getBoundingClientRect(),
      content: () => content.getBoundingClientRect(),
      sidebar: () => sidebar.getBoundingClientRect(),
      footer: () => footer.getBoundingClientRect()
    });

    let lastContent: { width: number, height: number } = null;
    this.contentObserver = new (window as any).ResizeObserver(() => {

      if (!lastContent || lastContent.width != content.clientWidth || lastContent.height != content.clientHeight) {
        lastContent = { width: content.clientWidth, height: content.clientHeight };

        this.layout.resize.emit({ ...lastContent, type: 'content', scope: content });
      }
    });
    this.contentObserver.observe(content);

    let lastWindow: { width: number, height: number } = null;
    this.windowObserver = () => {
      if (!lastWindow || lastWindow.width != window.innerWidth || lastWindow.height != window.innerHeight) {
        lastWindow = { width: window.innerWidth, height: window.innerHeight };

        this.layout.resize.emit({ ...lastWindow, type: 'layout', scope: document.body });
      }
    }    

    window.addEventListener('resize', this.windowObserver);
    this.windowObserver();
  }

  ngOnDestroy() {
    this.layout.use(null);
    if (this.contentObserver) this.contentObserver.disconnect();
    if (this.windowObserver) window.removeEventListener('resize', this.windowObserver)
  }
  
  update() {
  }

  hideSidebar(event) {
    event.stopPropagation();
    this.layout.sidebar = false;
  }
}
